export {
  now,
  timer,
  timerFlush
} from "./timer.js";

export {
  default as timeout
} from "./timeout.js";

export {
  default as interval
} from "./interval.js";



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-timer/src/index.js